import { Table } from "antd";
import React from "react";
import { useCollection } from "../../../hooks/useCollection";
import { ProductionPopup } from "./ProductionPopup";

export default function ProductionCosts() {
   const { loading, data } = useCollection("productionCosts");
   const columns = [
      {
         title: "Machine",
         dataIndex: "machine",
      },
      {
         title: "Costs",
         dataIndex: "costs",
         align: "center",
         sorter: {
            compare: (a, b) => a.costs - b.costs,
         },
      },
      {
         title: "Adjust Meters",
         dataIndex: "adjustRunningMeters",
         align: "center",
         sorter: {
            compare: (a, b) => a.adjustRunningMeters - b.adjustRunningMeters,
         },
      },
      {
         title: "Meters/Min",
         dataIndex: "runningMetersMin",
         align: "center",
         sorter: {
            compare: (a, b) => a.runningMetersMin - b.runningMetersMin,
         },
      },
      {
         title: "Timer per Min",
         dataIndex: "timeperminute",
         align: "center",
         sorter: {
            compare: (a, b) => a.timeperminute - b.timeperminute,
         },
      },
      {
         render: (value) => (
            <ProductionPopup
               title={value.machine}
               costs={value.costs}
               id={value.id}
               adjustRunningMeters={value.adjustRunningMeters}
               runningMetersMin={value.runningMetersMin}
               timeperminute={value.timeperminute}
            />
         ),
      },
   ];

   const onChange = (pagination, filters, sorter, extra) => {
      console.log("params", pagination, filters, sorter, extra);
   };
   return (
      <div>
         <Table columns={columns} size="small" loading={loading} dataSource={data} onChange={onChange} pagination={false} />
      </div>
   );
}
